<template>
  <div v-if="loading" class="ui active centered inline loader">
    <div class="ui text loader">{{ $t('loading') }}...</div>
  </div>
  <div v-else class="ui segment">
    <div class="centered-header">
      <h2 class="ui header" style="color: #092442;">
        <i class="dolly flatbed icon"></i>
        <div class="content">
          {{ supplier.name }}
        </div>
      </h2>
    </div>

    <div class="ui grid" style="margin-top: 10px">
      <div class="row">
        <div class="column">
          <h4 class="ui dividing header">
            Basic Information
          </h4>
          <abstractTable
            :data="supplierInfo"
            :definitionTable="true"
            :definitionTableWidth="'20%'"
            :classes="'ui compact definition table'"
          />
        </div>
      </div>
      <div class="row">
        <div class="column">
          <h4 class="ui dividing header">
            Branches Information
          </h4>
          <div class="ui three column grid">
            <div class="column" v-for="(branch, index) in supplier.branches">
              <div class="ui green segment">
                <div class="centered-header">
                  <h3 class="ui header" style="color: #092442;">
                    <div class="content">
                      <i class="map marker alternate icon"></i>
                      branch # {{ index + 1 }}
                    </div>
                  </h3>
                </div>
                <div class="ui divider"></div>
                <div class="description">
                  <strong> Address: </strong> {{ branch.address }}
                </div>
                <abstractTable
                  :columns="telephonesColumns"
                  :data="telephonesData(branch.telephones)"
                  :classes="'ui tablet very compact center aligned very celled table'"
                  v-if="telephonesData(branch.telephones).length"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    abstractTable: require('@/components/abstract_components/AbstractTable').default
  },
  data () {
    return {
      supplier: {},
      loading: true
    }
  },
  mounted () {
    this.$http.get(`companies/${this.$route.params.id}`).then(response => {
      this.supplier = response.data
      this.loading = false
    })
  },
  computed: {
    supplierInfo () {
      return {
        email: this.supplier.email,
        'Number Of Branches': this.supplier.branches.length
      }
    },
    telephonesColumns () {
      return [
        { header: 'Telephone Type', fieldName: 'telephone_type', show: true },
        { header: 'Telephone', fieldName: 'number', show: true }
      ]
    }
  },
  methods: {
    telephonesData (telephones) {
      let formlatedTelephones = []

      window._.each(telephones, telephone => {
        formlatedTelephones.push({
          telephone_type: telephone.telephone_type.name,
          number: telephone.number
        })
      })

      return formlatedTelephones
    }
  }
}
</script>

<style scoped>
  .centered-header {
    display: flex;
    justify-content: center;
  }
  .virtical-center {
    display: flex !important;
    align-items: center !important;
    float: left;
  }
</style>



// WEBPACK FOOTER //
// src/components/inventory_system/companies/Company.vue